import bindFactoryPlayerEvents from './utils/bindFactoryPlayerEvents';
import generateFetchFactory from './generateFetchFactory';
import {
  FetchFactoryOptions,
  FetchFactory
} from '@kollective-frontend/ksdk-api';
import { Types, checkType, TypeDeterminer } from '../util/checkTypes';
import FactoryPlayerInteractionBase from './FactoryPlayerInteractionBase';

export default class FetchFactoryPlayerInteraction extends FactoryPlayerInteractionBase<FetchFactoryOptions> {
  readonly fetchFactory: FetchFactory;

  constructor(options: FetchFactoryOptions) {
    checkType(options, Types.FETCH_FACTORY).emitErrorIfNotCorrectType();
    super(options);
    this.cleanupMethods.push(bindFactoryPlayerEvents(options));
    this.fetchFactory = generateFetchFactory(this.binder);
    options.setFetchFactory(this.fetchFactory);
  }

  setSourceType(): TypeDeterminer {
    return Types.FETCH_FACTORY_SET_SOURCE;
  }
}
